import { Preco } from "./style";

function PrecosComponent() {
  return (
    <Preco>
      <div id="pather-div">
        <div id="div-header">
          <h1>Preço do mercado atual!</h1>
          <p>
            Veja o que você pagaria por tudo que ofereço, com um investimento de 
            <span> 2 anos!!!</span>
          </p>
        </div>
        <section id="all-precos">
            
          <article className="art-precos">
            <div className="description">
              <p>
                <span>2 anos de curso regular de inglês</span> em escolas de idiomas ou com
                professor particular. Valor médio entre matrícula, mensalidade e
                material.
              </p>
            </div>
            <div className="precos">R$ 13.208,00</div>
          </article>
          <article className="art-precos">
            <div className="description">
              <p>
                <span>Avaliação Inicial</span><br/>Teste e entrevista de nivelamento +
                Consultoria Comportamental
              </p>
            </div>
            <div className="precos">R$ 970,00</div>
          </article>
          <article className="art-precos">
            <div className="description">
              <p>
                <span>Customização de Experiência</span><br/>Contato com conteúdos e vocabulários
                da área do cliente
              </p>
            </div>
            <div className="precos">R$ 1.490,00</div>
          </article>
          <article className="art-precos">
            <div className="description">
              <p>
                <span>Revisão de Ciclo e Replanejamento</span><br/>Aplicação de ferramentas de
                checagem de desempenho e resultados. Replanejamento para o
                próximo ciclo (repete por 4x)
              </p>
            </div>
            <div className="precos">R$ 1.260,00</div>
          </article>
          <article className="art-precos">
            <div className="desc-total">
              <p>Bônus Exclusivos</p>
            </div>
            <div className="precos">R$ 1.490,00</div>
          </article>
          <article className="art-precos">
            <div className="desc-total">
              <p>TOTAL:</p>
            </div>
            <div className="precos">R$ 18.418,00</div>
          </article>
        </section>
      </div>
    </Preco>
  );
}

export default PrecosComponent;
